import React from "react";
import heroImage from "../../assets/images/Herosection/herobanner.jpg"; // replace with your image path

const HeroSection = () => {
  const brandGold = "#E3B66B";

  return (
    <section className="relative bg-[#0a0a0a] text-white pt-48 ">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Law Expertise"
          className="w-full h-full object-cover brightness-50"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center lg:text-left">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold uppercase leading-tight mb-6">
          Protecting Your <br />
          <span style={{ color: brandGold }}>Rights & Interests</span>
        </h1>

        <p className="text-gray-300 text-lg md:text-xl mb-8">
          Nyaysakti Law Firm provides expert legal guidance with 20+ years of
          experience. Trusted by clients for transparency, dedication, and
          results.
        </p>

        <div className="flex flex-col md:flex-row justify-center lg:justify-start gap-4">
          <a
            href="/contact-us"
            className="relative inline-block px-8 py-3 font-bold uppercase tracking-widest border border-[#E3B66B] text-[#E3B66B] overflow-hidden group"
          >
            <span className="relative z-10 transition-colors duration-300 group-hover:text-black">
              Schedule Consultation
            </span>

            {/* sliding background */}
            <span className="absolute bottom-0 left-0 w-full h-full bg-[#E3B66B] transform translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out"></span>
          </a>

          <a
            href="/practice-areas"
            className="px-8 py-3 font-bold uppercase tracking-widest border border-white/20 rounded hover:border-[#E3B66B] hover:text-[#E3B66B] transition-all duration-300"
          >
            Practice Areas
          </a>
        </div>
      </div>

      {/* Decorative Text Watermark */}
   <div className="absolute bottom-[350px] lg:bottom-[200px] md:bottom-[200px] left-1/2 -translate-x-1/2 text-[20vw] font-black text-white/5 leading-none select-none pointer-events-none uppercase">
  Justice
</div>


    </section>
  );
};

export default HeroSection;
